import React, { useState, useEffect } from "react"; 
import { NavLink, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  // Icon untuk Logout
  LogoutOutlined,
  
  // Icon untuk Dashboard
  HomeOutlined,
  
  // Icon untuk Register Usulan
  DescriptionOutlined,
  
  // Icon untuk Rekap Usulan
  ReceiptOutlined,
  RequestQuoteOutlined,
  
  // Icon untuk Rekapitulasi
  BarChartOutlined,
  
  // Icon untuk Data Validasi
  CheckCircleOutlineOutlined,
  VerifiedUser,
  
  // Icon untuk Sebaran Lokasi
  LocationOnOutlined,
  
  // Icon untuk Upload Foto
  PhotoCameraOutlined,
  
  // Icon untuk Data Backlog
  FamilyRestroom,
  InventoryOutlined,
  
  // Icon untuk Tambah Data
  AddCircleOutlineOutlined,
  
  // Icon untuk Menu Admin
  PersonAddAltOutlined,
  PictureAsPdfOutlined,
  GroupOutlined,
  
  // Icon untuk Menu Bantuan (Langsung di sidebar)
  AssignmentOutlined,
  AnalyticsOutlined,
  TrendingUpOutlined,
  PieChartOutlined,
  ReportProblemOutlined,
  MonitorHeartOutlined,
  ShoppingCartOutlined,
  PointOfSaleOutlined,
  SupervisorAccountOutlined,
  Gavel,
  
} from "@mui/icons-material";
import { LogOutAdmin, reset, getMeAdmin } from "../../fitur/AuthSlice";
import { getSidebarItems, ROLE_META } from "../../config/roleConfig";

const PATH_ICONS = {
  "/admin/dashboard": <HomeOutlined />,
  "/agr/dashboard": <HomeOutlined />,
  "/tfl/dashboard": <HomeOutlined />,
  "/fasilitator/dashboard": <HomeOutlined />,
  "/supplier/dashboard": <HomeOutlined />,
  "/ppk/dashboard": <HomeOutlined />,
  "/kabid/dashboard": <HomeOutlined />,
  "/kadis/dashboard": <HomeOutlined />,
  "/bupati/dashboard": <HomeOutlined />,
  "/kepaladinas/dashboard": <HomeOutlined />,
  "/registerdata": <DescriptionOutlined />,
  "/rekapdatabantuanrumah": <ReceiptOutlined />,
  "/recap": <BarChartOutlined />,
  "/recapVerifikasi": <CheckCircleOutlineOutlined />,
  "/maps": <LocationOnOutlined />,
  "/upload": <PhotoCameraOutlined />,
  "/backlog": <InventoryOutlined />,
  "/questionnaire": <FamilyRestroom />,
  "/Verifikasi": <VerifiedUser />,
  "/register": <PersonAddAltOutlined />,
  "/uploadpdf": <PictureAsPdfOutlined />,
  "/userlist": <GroupOutlined />,
  "/data-bantuan": <AssignmentOutlined />,
  "/monitoring-bantuan": <MonitorHeartOutlined />,
  "/rekap-bantuan": <AnalyticsOutlined />,
  "/proses-bantuan": <TrendingUpOutlined />,
  "/presentase-bantuan": <PieChartOutlined />,
  "/keluhan": <ReportProblemOutlined />,
  "/data-supplier": <AssignmentOutlined />,
  "/input-pembelian": <PointOfSaleOutlined />,
  "/data-pembelian-supplier": <ShoppingCartOutlined />,
  '/laporan-rab-supplier': <AssignmentOutlined />,
  '/data-upah-tukang': <AssignmentOutlined />,
  '/koordinator-tfl/dashboard': <SupervisorAccountOutlined />,
  '/koordinator-tfl/monitoring': <SupervisorAccountOutlined />,
  '/data-sk': <Gavel />,
  '/supplier/bukti-transfer': <ReceiptOutlined />,
  '/supplier/penagihan': <RequestQuoteOutlined />,
};

const getIconForPath = (path) => PATH_ICONS[path] || <AssignmentOutlined />;

export const Sidebar = ({ onCloseDrawer, isMobile = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const auth = useSelector((state) => state.authAdmin || {});
  const user = auth.user || null;

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openAddDataDialog, setOpenAddDataDialog] = useState(false);

  useEffect(() => {
    dispatch(getMeAdmin());
  }, [dispatch]);

  const handleLogoutClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenConfirmDialog(true);
  };

  const handleConfirmLogout = () => {
    dispatch(LogOutAdmin());
    dispatch(reset());
    navigate("/");
    setOpenConfirmDialog(false);
  };

  const handleCancelLogout = () => {
    setOpenConfirmDialog(false);
  };

  const handleOpenAddDataDialog = () => {
    if (isMobile && onCloseDrawer) {
      onCloseDrawer();
    }
    setTimeout(() => {
      setOpenAddDataDialog(true);
    }, 100);
  };

  const handleCloseAddDataDialog = () => {
    setOpenAddDataDialog(false);
  };

  const handleNavigateToQuestionnaire = () => {
    handleCloseAddDataDialog();
    navigate("/questionnaire");
  };

  const handleNavigateToVerifikasi = () => {
    handleCloseAddDataDialog();
    navigate("/Verifikasi");
  };

  const getNavItems = () => {
    if (!user?.role) {
      return [{ to: "/login", text: "Login", icon: <HomeOutlined /> }];
    }
    return getSidebarItems(user.role).map((item) => ({
      ...item,
      icon: getIconForPath(item.to),
    }));
  };

  const navItems = getNavItems();

  const hasAddDataAccess = user && (user.role === "admin" || user.role === "surveyor");
  const roleLabel = ROLE_META[user?.role]?.label || user?.role;

  const addDataItems = [
    {
      text: "Pendataan dan Verifikasi Rehabilitasi",
      icon: <FamilyRestroom />,
      onClick: handleNavigateToQuestionnaire,
      color: "#0A5EB0",
      hoverColor: "#084B8A",
    },
    {
      text: "Pendataan dan Verifikasi Bangun Baru",
      icon: <VerifiedUser />,
      onClick: handleNavigateToVerifikasi,
      color: "#2E8B57",
      hoverColor: "#1D5F3A",
    },
  ];

  const sidebarStyles = {
    background: "linear-gradient(180deg, #0A5EB0 0%, #084B8A 100%)",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    width: isMobile ? "100%" : { xs: 200, lg: 250 },
    position: isMobile ? "relative" : "fixed",
    top: 0,
    left: 0,
    p: 2,
    zIndex: 1200,
    overflowY: "auto",
    boxShadow: "4px 0 10px rgba(0, 0, 0, 0.2)",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(255, 255, 255, 0.05)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#B1F0F7",
      borderRadius: "10px",
      "&:hover": {
        backgroundColor: "#90E0E7",
      },
    },
  };

  /**
   * KOMPONEN RENDER UNTUK MENU ITEM
   * Digunakan untuk merender setiap item menu dengan konsisten
   */
  const renderMenuItem = (item, isActive) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        color: isActive ? "#fff" : "rgba(255, 255, 255, 0.8)",
        padding: "10px 16px",
        borderRadius: "10px",
        transition: "all 0.3s ease",
        backgroundColor: isActive ? "rgba(177, 240, 247, 0.25)" : "transparent",
        boxShadow: isActive ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
        "&:hover": {
          backgroundColor: "rgba(177, 240, 247, 0.15)",
          color: "#fff",
          transform: "translateX(5px)",
        },
        position: "relative",
      }}
    >
      <Box sx={{
        mr: 2,
        fontSize: "20px",
        opacity: isActive ? 1 : 0.8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "24px",
      }}>
        {item.icon}
      </Box>
      <Typography
        sx={{
          fontWeight: isActive ? 600 : 400,
          fontSize: "14px",
          flex: 1,
        }}
      >
        {item.text}
      </Typography>
      {isActive && (
        <Box
          sx={{
            width: "4px",
            height: "70%",
            bgcolor: "#B1F0F7",
            borderRadius: "4px",
            ml: "auto",
            position: "absolute",
            right: "8px",
          }}
        />
      )}
    </Box>
  );

  // ============================================
  // RENDER UTAMA SIDEBAR
  // ============================================
  
  return (
    <>
      <Box sx={sidebarStyles}>
        {/* ===== HEADER / LOGO ===== */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 3,
            position: "relative",
            mb: 4,
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: 0,
              left: "10%",
              width: "80%",
              height: "2px",
              background: "linear-gradient(90deg, transparent, #B1F0F7, transparent)",
            },
            transition: "transform 0.3s ease",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
        >
          <img
            src="/images/logobaru.svg"
            alt="Logo Aplikasi"
            className="homelogo"
            style={{
              width: "85px",
              height: "85px",
              marginBottom: "12px",
              filter: "drop-shadow(0 4px 6px rgba(0, 0, 0, 0.2))",
              transition: "all 0.3s ease",
            }}
          />

          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "15px",
              lineHeight: "1.4",
              letterSpacing: "0.5px",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          >
            Sistem Informasi Digital <br />
            Layanan dan Manajemen Perumahan
          </Typography>
          {user?.username && (
            <Typography
              variant="caption"
              sx={{
                mt: 1,
                color: "rgba(255,255,255,0.85)",
                textAlign: "center",
                display: "block",
              }}
            >
              {user.username}
              {roleLabel ? ` · ${roleLabel}` : ""}
            </Typography>
          )}
        </Box>

        {/* ===== MENU UTAMA ===== */}
        <Stack
          spacing={1.5}
          sx={{
            flex: 1,
            px: 0.5
          }}
        >
          {/* ===== MENU UTAMA ===== */}
          {navItems.map((item) => (
            <NavLink
              to={item.to}
              key={item.to}
              style={{ textDecoration: "none" }}
              onClick={() => {
                if (isMobile && onCloseDrawer) {
                  onCloseDrawer();
                }
              }}
            >
              {({ isActive }) => renderMenuItem(item, isActive)}
            </NavLink>
          ))}

        

          {/* ===== TOMBOL TAMBAH DATA ===== */}
          {hasAddDataAccess && (
            <Button
              onClick={handleOpenAddDataDialog}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                color: "rgba(255, 255, 255, 0.9)",
                padding: "10px 16px",
                borderRadius: "10px",
                backgroundColor: "transparent",
                transition: "all 0.3s ease",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "rgba(177, 240, 247, 0.15)",
                  color: "#fff",
                  transform: "translateX(5px)",
                },
              }}
              startIcon={
                <AddCircleOutlineOutlined sx={{ fontSize: "20px", opacity: 0.8 }} />
              }
            >
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  marginLeft: 1
                }}
              >
                Tambah Data
              </Typography>
            </Button>
          )}

          {/* ===== TOMBOL LOGOUT ===== */}
          <Button
            onClick={handleLogoutClick}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              color: "rgba(255, 255, 255, 0.9)",
              padding: "10px 16px",
              borderRadius: "10px",
              backgroundColor: "rgba(251, 65, 65, 0.2)",
              transition: "all 0.3s ease",
              textTransform: "none",
              marginTop: 4,
              "&:hover": {
                backgroundColor: "rgba(251, 65, 65, 0.4)",
                transform: "translateY(-2px)",
              },
            }}
            startIcon={
              <LogoutOutlined sx={{ fontSize: "20px" }} />
            }
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "14px",
                marginLeft: 1
              }}
            >
              Log Out
            </Typography>
          </Button>
        </Stack>

        {/* ===== FOOTER ===== */}
        <Box
          sx={{
            mt: 4,
            pt: 2,
            pb: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderTop: "1px solid rgba(177, 240, 247, 0.3)",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "rgba(255, 255, 255, 0.7)",
              textAlign: "center",
              fontSize: "10px",
              lineHeight: 1.4,
            }}
          >
            ©{new Date().getFullYear()} Dinas Perumahan dan Permukiman Kabupaten Sumbawa Barat.
          </Typography>
          <Typography
            variant="caption"
            sx={{
              textAlign: "center",
              color: "rgba(255,255,255,0.5)",
              mt: 1,
              fontSize: "10px"
            }}
          >
            SI-DALIMAH v0.2.0
          </Typography>
        </Box>
      </Box>

      {/* ============================================
          DIALOG LOGOUT
          ============================================ */}
      {createPortal(
        <Dialog
          open={openConfirmDialog}
          onClose={handleCancelLogout}
          PaperProps={{
            sx: {
              borderRadius: "12px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
              p: 1
            }
          }}
          sx={{
            zIndex: 9999
          }}
        >
          <DialogTitle sx={{
            fontSize: "1.2rem",
            fontWeight: 600,
            color: "#0A5EB0"
          }}>
            Konfirmasi Logout
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Apakah Anda yakin ingin keluar dari aplikasi?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ pb: 2, px: 3 }}>
            <Button
              onClick={handleCancelLogout}
              sx={{
                color: "#5A5A5A",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.04)"
                }
              }}
            >
              Batal
            </Button>
            <Button
              onClick={handleConfirmLogout}
              variant="contained"
              color="error"
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                boxShadow: "0 4px 6px rgba(251, 65, 65, 0.2)",
                "&:hover": {
                  boxShadow: "0 6px 8px rgba(251, 65, 65, 0.3)",
                }
              }}
              autoFocus
            >
              Keluar
            </Button>
          </DialogActions>
        </Dialog>,
        document.body
      )}

      {/* ============================================
          DIALOG TAMBAH DATA
          ============================================ */}
      {createPortal(
        <Dialog
          open={openAddDataDialog}
          onClose={handleCloseAddDataDialog}
          PaperProps={{
            sx: {
              borderRadius: "12px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
              p: 1,
              maxWidth: { xs: "90vw", sm: 400 },
              width: "100%",
              m: 2,
            }
          }}
          sx={{
            zIndex: 9999
          }}
        >
          <DialogTitle sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem" },
            fontWeight: 600,
            color: "#0A5EB0"
          }}>
            Pilih Jenis Pendataan
          </DialogTitle>
          <DialogContent sx={{ minWidth: { xs: "auto", md: 350 } }}>
            <DialogContentText sx={{ mb: 2, fontSize: { xs: "0.9rem", sm: "1rem" } }}>
              Pilih salah satu opsi di bawah ini untuk memulai pendataan baru.
            </DialogContentText>
            <Stack spacing={2}>
              {addDataItems.map((item, index) => (
                <Button
                  key={index}
                  onClick={item.onClick}
                  variant="contained"
                  fullWidth
                  sx={{
                    borderRadius: "8px",
                    textTransform: "none",
                    py: 1.5,
                    fontWeight: 600,
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    backgroundColor: item.color,
                    "&:hover": {
                      backgroundColor: item.hoverColor,
                    }
                  }}
                  startIcon={item.icon}
                >
                  {item.text}
                </Button>
              ))}
            </Stack>
          </DialogContent>
          <DialogActions sx={{ pb: 2, px: 3 }}>
            <Button
              onClick={handleCloseAddDataDialog}
              sx={{
                color: "#5A5A5A",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.04)"
                }
              }}
            >
              Batal
            </Button>
          </DialogActions>
        </Dialog>,
        document.body
      )}
    </>
  );
};

export default Sidebar;